import restaurant from "./restaurant.png";
import consumergoodsshop from "./consumergoodsshop.png";
import hospital from "./hospital.png";
import transport from "./transport.png";
import school from "./school.png";
import office from "./office.png";
// import Special from "./Special.png";
import market from "./market.png";
import theater from "./theater.png";
import stadium from "./stadium.png";
import bank from "./bank.png";
import streetart from "./streetart.png";
import hotel from "./hotel.png";
import university from "./university.png";
import bar from "./bar.png";
import nightclub from "./nightclub.png";
import gym from "./gym.png";
import gasstation from "./gasstation.png";
import museum from "./museum.png";
import clothesstore from "./clothesstore.png";
import sportfield from "./sportfield.png";
import foodstop from "./foodstop.png";
import monument from "./monument.png";
import landmark from "./landmark.png";
import services from "./services.png";

const categoriesIcons = {
  transport,
  foodstop,
  streetart,
  clothesstore,
  consumergoodsshop,
  bar,
  gym,
  nightclub,
  sportfield,
  restaurant,
  school,
  office,
  gasstation,
  theater,
  hotel,
  hospital,
  services,
  market,
  bank,
  university,
  museum,
  stadium,
  monument,
  landmark,
  // 7: Special, //showStar
};

export default categoriesIcons;

// export default function CATEGORIESICONS(name) {
//   return _categoriesIcons[name];
// }
